import React from "react"
import { Link } from "gatsby"

export const BreadcrumbLink = ({ ressort, content, link }) => {
  return (
    <div className="level-item help is-marginless">
      <Link to={link} className={`link has-text-${ressort}`}>
        {content}
      </Link>
    </div>
  )
}
